export default function () {
  return [
    {
      path: '/contacts',
      component: () => import(/* webpackChunkName: 'message' */ '@views/message/contacts'),
      name: 'Contacts',
      meta: {
        needLogin: true
      }
    },
    {
      path: '/friends',
      component: () => import(/* webpackChunkName: 'message' */ '@views/message/friends'),
      name: 'friends',
      meta: {
        needLogin: true
      }
    },
    {
      path: '/interaction',
      component: () => import(/* webpackChunkName: 'message' */ '@views/message/interaction'),
      name: 'interaction',
      meta: {
        needLogin: true
      }
    },
    {
      path: '/conversation',
      component: () => import(/* webpackChunkName: 'message' */ '@views/message/conversation'),
      name: 'conversation',
      meta: {
        needLogin: true
      }
    },
    {
      path: '/contact-detail',
      component: () => import(/* webpackChunkName: 'message' */ '@views/message/contactDetail'),
      name: 'contactDetail',
      meta: {
        needLogin: true
      }
    },
    {
      path: '/search-users',
      component: () => import(/* webpackChunkName: 'message' */ '@views/message/searchUsers'),
      name: 'searchUsers',
      meta: {
        needLogin: true
      }
    },
    {
      path: '/messagePrivate',
      component: () => import(/* webpackChunkName: 'message' */ '@views/message/messagePrivate'),
      name: 'MessagePrivate',
      meta: {
        needLogin: true
      }
    }
  ];
};
